import React, { Component } from 'react';
import { Popover, Icon } from '@tinper/next-ui';
// import FilterDefined from './filterDefined';
import FilterModal from './FilterModal/FilterModal';
import DataLoader from '../../utils/query_scheme/data_loader';
import './style'
import { ENV_RENDER_DESIGNER } from '../../utils/constants'
import { cloneDeep } from 'lodash';
import { when, reaction } from 'mobx';
import FilterEditor from './FilterModal/FilterEditor';

class QueryScheme extends Component {
  endLoading = null; // 加载中蒙层

  state = {
    visible: false, // popover visible
    currentId: '', // 当前方案id
    schemeName: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800DF', '系统方案', undefined, {returnDom: true, placement: 'top'}), // 当前方案名
    User: null, // 当前用户权限
    showModal: false, // 新增/编辑方案弹窗
    schemeList: [], // 方案列表
    isEdit: false, // 是否为编辑方案
    conditionsList: [], // 候选条件列表
    solutionMetaInfo: { // 当前方案元数据信息
      fields: []
    },
    // definedVisible: false, // 自定义过滤条件
    systemScheme: {} // 系统方案
  }

  dataLoader = new DataLoader(this.props)

  // eslint-disable-next-line react/no-deprecated
  componentWillMount () {
    this.props.JSONSchema?.initParams?.(this.dataLoader.getParams)
    when(() => this.props.JSONSchema?.haveSystem, () => {
      this.init();
    });
    reaction(() => this.props.JSONSchema?.updateSchemeList, () => {
      const schemeList = this.props.JSONSchema?.schemeList
      // 更改系统方案的默认图标
      const { systemScheme } = this.state;
      let flag = true;
      schemeList.forEach(item => {
        if (item.isPublic && item.isDefault) flag = false; // 方案列表里已经有公共默认方案
      })
      systemScheme.isDefault = flag;
      let haveSystem = false;
      schemeList.forEach(item => {
        if (item.solutionId === 'systemScheme') {
          item.isDefault = flag
          haveSystem = true
        }
      })
      if (!haveSystem) schemeList.unshift(systemScheme); // 将系统方案拼到方案列表第一条
      this.setState({ schemeList, systemScheme });
    })
    reaction(() => this.props.JSONSchema?.updateScheme, () => {
      this.chooseScheme(this.props.JSONSchema.targetScheme)
    })
  }

  // 初始化
  init () {
    const list = cloneDeep(this.props.JSONSchema?.getContitionList());
    this.setState({ fieldsArr: list }, () => {
      // 如果不是设计器态
      if (this.props.renderEnv !== ENV_RENDER_DESIGNER) {
        this.createDefaultScheme();
        this.getDefaultQuerySchemaData();
        this.getCandidateConditionsList();
      }
    });
  }

  // 创建系统方案
  createDefaultScheme () {
    const fieldsArr = this.state.fieldsArr; // 获取所有查询区字段
    // 筛选默认字段
    const defaultFileds = [];
    fieldsArr.forEach(item => {
      if (item.meta.isSolution === true || item.meta.isSolution === undefined) {
        defaultFileds.push(cloneDeep(item.meta));
      }
    });
    const systemScheme = { // 系统方案
      caption: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800DF', '系统方案', undefined, {returnDom: true, placement: 'top'}),
      solutionId: 'systemScheme',
      isPublic: true,
      autoSearch: true,
      fields: defaultFileds,
      dataSource: this.props.dataSource // 数据源 查询区没有modelPath, 用dataSource指向列表数据
    }
    this.props.JSONSchema.systemScheme = systemScheme
    this.setState({ systemScheme });
  }

  // 获取用户默认查询方案
  async getDefaultQuerySchemaData () {
    // 获取用户自定义方案中的默认方案
    let currentScheme = await this.dataLoader.getDefaultQuerySchema();
    // 默认系统方案与查询区一致
    const isUserDefaultQuerySchema = currentScheme
    // 用户没有设置自定义方案, 或自定义方案中没有默认方案, 就用系统方案
    if (!currentScheme || (currentScheme && !currentScheme.isDefault)) {
      const { systemScheme } = this.state;
      systemScheme.isDefault = true;
      this.setState({ systemScheme });
      currentScheme = this.state.systemScheme;
    }
    this.setState({ schemeName: currentScheme.caption, currentId: currentScheme.solutionId });
    this.props.JSONSchema.currentScheme = currentScheme
    this.props.initDefaltSchema?.(currentScheme);
    if (isUserDefaultQuerySchema?.isDefault) {
      const _value = await this.createCondition(currentScheme)
      this.props.JSONSchema?.setCondition?.(_value)
      this.props.JSONSchema?.setUpdate?.();
    }
    if (currentScheme.autoSearch) { // 是否自动搜索
      this.props.JSONSchema?.copyCondition?.(); // 把全部条件中激活的条件 copy 到 queryCondition 里面
      this.props.JSONSchema?.setQueryTrigger?.(); // 触发自动查询
    }
  }

  // 获取候选条件列表
  async getCandidateConditionsList () {
    const conditionsList = this.props.JSONSchema?.getCandidateConditionsList?.(this.state.fieldsArr, { parentAlias: this.props.parentAlias })
    this.setState({ conditionsList });
  }

  // 渲染方案列表
  renderSchemeList () {
    const { schemeList, User } = this.state;
    const { currentId } = this.state;
    const userdef_schemaSetting = User && User.userdef_schemaSetting
    const schemeListTem = [];

    if (schemeList.length > 0) {
      schemeList.forEach((element, index) => {
        const showDele = !element.isDefault;
        // 扩展字段配置方案不可删除
        // const prohibitDeletion = element.cExtProps && parseCStyle(element.cExtProps)?.prohibitDeletion;
        const isChecked = element.solutionId === currentId; // 是否选中
        const itemChecked = isChecked ? <span className='groupCondition-Checked'><Icon type="uf-correct-2" className='yonicon' checked={isChecked} /></span> : <span className='groupCondition-Checked' />;
        const itemPublic = !element.isPublic ? <span className='groupCondition-Default'><span className='public-btn'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800DC', '个人', undefined, {returnDom: true, placement: 'top'})}</span></span> : <span className='groupCondition-Default' />;
        const isDefault = element.isDefault ? element.isDefault : false; // 是否为默认方案
        const itemDefault = isDefault ? <span className='groupCondition-Default'><span className="crossdefaultBtn">{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800DD', '默认', undefined, {returnDom: true, placement: 'top'})}</span></span> : <span className='groupCondition-Default' />;
        const isMouseEnter = element.isMouseEnter ? element.isMouseEnter : false; // 鼠标移入
        const itemText =
          // element.mobileFilte ?
          //   <span style={{ cursor: 'not-allowed' }}>
          //     {element.caption ? element.caption : element.solutionId}
          //   </span>
          //   :
          <span style={{ cursor: 'pointer' }} fieldid={`${this.getFieldId()}|${element.caption ? element.caption : element.solutionId}`} onClick={() => this.chooseScheme(element)}>
            {element.caption ? element.caption : element.solutionId}
          </span>
        const deleteTem = <span className='Noclose' fieldid={`${this.getFieldId()}|deleteScheme`} onClick={() => this.deleteScheme(element.solutionId)} style={{ display: showDele == true ? 'inline' : 'none' }}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800E2', '删除', undefined, {returnDom: true, placement: 'top'})}</span>;
        let itemHover = '';
        if (element.isPublic) {
          itemHover = isMouseEnter
            ? <span className='groupCondition-MouseEnter'>
              {isDefault
                ? null
                : userdef_schemaSetting
                  ? <span className='stopclose' fieldid={`${this.getFieldId()}|setdefault`} onClick={(e) => this.setDefaultScheme(element.solutionId, e)}>
                    {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800DE', '设为默认', undefined, {returnDom: true, placement: 'top'})}
                  </span>
                  : null
              }
              {userdef_schemaSetting ? <span onClick={() => this.editSchemeInfo(element)} fieldid={`${this.getFieldId()}|schemeSetting`}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800E0', '设置', undefined, {returnDom: true, placement: 'top'})}</span> : <span />}
              {/* { prohibitDeletion ? <span /> : userdef_schemaSetting ? deleteTem : <span /> } */}
              {element.solutionId !== 'systemScheme' && userdef_schemaSetting ? deleteTem : null}
            </span>
            : <span className='groupCondition-MouseEnter' />;
        } else {
          itemHover = isMouseEnter
            ? <span className='groupCondition-MouseEnter'>
              {isDefault ? null : <span className='stopclose' fieldid={`${this.getFieldId()}|setSchemeDefault`} onClick={(e) => this.setDefaultScheme(element.solutionId, e)}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800DE', '设为默认', undefined, {returnDom: true, placement: 'top'})}</span>}
              <span onClick={() => this.editSchemeInfo(element)} fieldid={`${this.getFieldId()}|schemeSetting`}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800E0', '设置', undefined, {returnDom: true, placement: 'top'})}</span>
              {element.solutionId === 'systemScheme' ? null : deleteTem}
            </span>
            : <span className='groupCondition-MouseEnter' />;
        }
        const rowCheckedStyle = isChecked ? { backgroundColor: 'var(--wui-base-item-bg-selected)', minHeight: '36px' } : { minHeight: '36px' }
        const listItem = <div
          className='yonRow yon-row'
          key={index}
          style={rowCheckedStyle}
          onMouseLeave={() => this.onMouseEnterSchemeItem()}
          onMouseEnter={() => this.onMouseEnterSchemeItem(element.solutionId)}
        >
          {itemChecked}
          {itemText}
          {itemPublic}
          {itemDefault}
          {itemHover}
        </div>
        schemeListTem.push(listItem);
      });
    }
    return (
      <div className='group-add-grouping-count'>
        <div className="ynf-scheme-list-content add-personal-plan">
          <div className='public-plan'>
            <div className='public-plan-name'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800E3', '查询方案列表', undefined, {returnDom: true, placement: 'top'})}</div>
            {schemeListTem}
          </div>
        </div>
        <div className='add-scheme group-grouping'>
          <div className="add-scheme-button" onClick={this.addScheme} fieldid={`${this.getFieldId()}|addScheme`}>
            {/* <svg type='plus' className='icon'><use xlinkHref={`#icon-plus`} /></svg> */}
            {/* <SvgIcon type='plus' /> */}
            {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8010D', '新增方案', undefined, {returnDom: true, placement: 'top'})}
            {/* 新增方案 */}
          </div>
        </div>
      </div>
    );
  }

  // 鼠标移入方案item, 展示hover按钮
  onMouseEnterSchemeItem (solutionId) {
    const { schemeList } = this.state;
    if (schemeList.length > 0) {
      schemeList.forEach(ele => {
        if (solutionId == ele.solutionId) {
          ele.isMouseEnter = solutionId;
        } else {
          ele.isMouseEnter = false
        }
      })
    }
    this.setState({ schemeList });
  }



  // 切换方案
  chooseScheme = async (val) => {
    this.setState({ visible: false, schemeName: val.caption, currentId: val.solutionId });
    const _value = await this.createCondition(val)
    this.props.onChange?.(_value);
    this.props.JSONSchema?.chooseScheme?.(val)
    this.props.JSONSchema?.setCondition?.(_value)
    this.props.JSONSchema?.setUpdate?.();
    // 执行搜索
    if (val.autoSearch) { // 是否自动搜索
      this.props.JSONSchema?.copyCondition?.(); // 把全部条件中激活的条件 copy 到 queryCondition 里面
      const validateResult = this.props.JSONSchema?.validate?.()
      if (validateResult.length) {
        return this.props.JSONSchema?.utils.message.danger({
          content: validateResult.map((item) => {
            return <div key={item.name}>{item.message}</div>;
          })
        });
      } else {
        this.props.JSONSchema?.setQueryTrigger?.(); // 触发自动查询
      }
    }
  }

  // 组装filterStore需要的值
  createCondition = async (val) => {
    const multiRes = await this.props.JSONSchema?.getMultiRes?.()
    // 先把所有的字段置为不活跃
    const valNameArr = val.fields?.map(item => item.storeField)
    const old = this.state.fieldsArr.map(item => {
      item.activated = false;
      item.visible = false;
      return item;
    }).filter(item => !valNameArr.includes(item.meta?.storeField))
    let fields = []
    if (!val.meta) {
      fields = val.fields.map(i => {
        return {
          name: i.storeField,
          value: i.value || i.defaultValue || undefined,
          operator: i.compareLogic,
          activated: true,
          visible: i.visible !== false,
          meta: this.props.JSONSchema?.multilingualMeta?.(i, multiRes)
        }
      })
    }
    const _value = [...old, ...fields];
    return _value
  }

  // 打开新增方案弹窗
  addScheme = () => {
    this.props.JSONSchema?.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8010D', '新增方案', undefined, { returnStr: true }) || '新增方案')
    this.setState({ visible: false, showModal: true, isEdit: false, solutionMetaInfo: { fields: [] } });
  }

  // 设置默认
  async setDefaultScheme (solutionId, e) {
    e.nativeEvent.stopImmediatePropagation();
    e.nativeEvent.stopPropagation();
    this.props.JSONSchema?.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A8EA85405580003', '设置默认查询方案', undefined, { returnStr: true }) || '设置默认查询方案')
    await this.props.JSONSchema?.setDefaultScheme?.(solutionId)
  }

  // 打开设置弹窗
  editSchemeInfo = (val) => {
    const data = this.props.JSONSchema?.getSolutionMetaBySchemeId?.(val)
    this.props.JSONSchema?.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A8EA8D205580004', '编辑查询方案', undefined, { returnStr: true }) || '编辑查询方案')
    this.setState({ solutionMetaInfo: data, visible: false, showModal: true, isEdit: true });
  }

  // 删除并更新列表
  async deleteScheme (solutionId) {
    this.props.JSONSchema?.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A8EA5FE05580008', '删除查询方案', undefined, { returnStr: true }) || '删除查询方案')
    await this.props.JSONSchema?.deleteScheme?.(solutionId)
    if (solutionId === this.props.JSONSchema?.currentScheme.solutionId) {
      this.chooseScheme(this.props.JSONSchema.systemScheme)
    }
  }

  // pop展示状态变更
  handleVisibleChange = () => {
    if (!this.state.User) {
      this.getauthority()
      return
    }
    if (this.state.schemeList.length === 0) {
      this.props.JSONSchema?.getSolutionDataList?.()
      this.setState({ visible: !this.state.visible });
      return
    }
    this.setState({ visible: !this.state.visible });
  }

  // 获取用户权限
  async getauthority () {
    try {
      const { code, data } = await this.dataLoader.checkAuthByCode();
      if (code === 200) {
        this.setState({ User: data }, () => { this.handleVisibleChange() });
      }
    } catch (error) {
    }
  }

  // 自定义过滤条件
  openDefined () {
    this.handleVisibleChange()
    if (this.state.User) {
      this.setState({ definedVisible: true })
    }
  }

  // 关闭新增/编辑方案弹窗
  closeAddModal = () => {
    this.setState({ showModal: false });
  }

  getFieldId = () => {
    const { fieldid, fieldidPrefix } = this.props || {};
    return fieldid || fieldidPrefix;
  };

  render () {
    if (this.props.visible === false) {
      return null;
    }
    const { definedVisible, User, showModal, isEdit, visible, schemeName, conditionsList, solutionMetaInfo, schemeList } = this.state;
    let { wrapStyle, renderEnv, degignDomAttr = {}, designDomClassName = '' } = this.props;
    try {
      wrapStyle = JSON.parse(wrapStyle)
    } catch (err) { }
    const popContent = <div className='filter-scheme Grouping-condition'>
      <div className='filter-scheme-input Grouping-condition-input'>
        <span className='filter-scheme-name'>
          {schemeName}
        </span>
        <Icon className='filter-scheme-icon' type={visible ? 'uf-arrow-up' : 'uf-anglearrowdown'} />
      </div>
    </div>
    // 设计器态
    if (renderEnv === ENV_RENDER_DESIGNER) {
      return (
        <div className={`ynf-scheme-list ${designDomClassName}`} style={wrapStyle} {...degignDomAttr}>
          <div className='scheme-popover'>{popContent}</div>
        </div>
      );
    }
    return (
      <div className={`ynf-scheme-list ${designDomClassName}`} style={wrapStyle} fieldid={`${this.getFieldId()}`} {...degignDomAttr}>
        <div className='scheme-popover'>
          {renderEnv !== ENV_RENDER_DESIGNER
            ? <Popover
              overlayClassName='default-scheme-popover'
              placement='bottomLeft'
              overlayStyle={{ width: '236px', zIndex: 2000 }}
              content={this.renderSchemeList()}
              trigger='click'
              visible={visible}
              onVisibleChange={this.handleVisibleChange}
            >
              {popContent}
            </Popover>
            : popContent
          }
        </div>
        <FilterModal
          showModal={showModal}
          isEdit={isEdit}
          currentId={this.state.currentId}
          deleteScheme={(solutionId) => this.deleteScheme(solutionId)}
          setDefaultScheme={(solutionId, e) => this.setDefaultScheme(solutionId, e)}
          editSchemeInfo={this.editSchemeInfo}
          User={User}
          AddScheme={this.addScheme}
          conditionsList={conditionsList}
          solutionMetaInfo={solutionMetaInfo}
          schemeList={schemeList}
          closeAddModal={this.closeAddModal}
          parentAlias={this.props.parentAlias}
          getSolutionDataList={this.props.JSONSchema?.getSolutionDataList?.bind(this)}
          dataSource={this.props.dataSource}
          chooseScheme={this.chooseScheme}
          fieldid={`${this.getFieldId()}|filterModal`}
          JSONSchema={this.props?.JSONSchema?.getJSONSchema('filtermodal')}
          dataLoader={this.dataLoader}
        />
      </div>
    );
  }
}

QueryScheme.FilterModal = FilterModal
QueryScheme.FilterEditor = FilterEditor
export default QueryScheme